import axios from "@/assets/js/api";

export default {
    name: "ContactusManagement",
    data() {
      return {
        contacts: [],  // 修改為 'contacts' 用來存儲聯絡資料
        searchQuery: "",
        currentPage: 1,
        itemsPerPage: 10,
        showEditModal: false,
        activeButton: "all", // 設置按鈕的默認狀態
        editContactData: {
          id: "",
          name: "",
          email: "",
          phone: "",
          message: "",
          createDate: "",
          reply: false,
        },        
      };
    },
    computed: {
        filteredContacts() {
            let result = this.contacts;
      
            // 根據當前選擇的按鈕篩選
            if (this.activeButton === "checkIn") {
              result = result.filter((contact) => contact.reply === true);
            } else if (this.activeButton === "checkOut") {
              result = result.filter((contact) => contact.reply === false);
            }
      
            // 根據搜尋關鍵字篩選
            const query = this.searchQuery.trim().toLowerCase();
            if (query) {
              result = result.filter(
                (contact) =>
                  contact.name.toLowerCase().includes(query) ||
                  contact.id.toString().includes(query)
              );
            }
      
            return result;
          },
          totalPages() {
            return Math.ceil(this.filteredContacts.length / this.itemsPerPage);
          },
          paginatedContacts() {
            const startIndex = (this.currentPage - 1) * this.itemsPerPage;
            return this.filteredContacts.slice(startIndex, startIndex + this.itemsPerPage);
          },
          hasNextPage() {
            return this.currentPage < this.totalPages;
          },
          hasPreviousPage() {
            return this.currentPage > 1;
          },
        },
        methods: {
            setActiveButton(buttonName) {
              this.activeButton = buttonName;
              this.currentPage = 1; // 重置頁碼到第一頁
            },
            async fetchContacts() {
              try {
                const response = await axios.get("/contactus");
                console.log("API 回應資料：", response.data); // 調試用
                this.contacts = response.data;
              } catch (error) {
                console.error("獲取聯絡資料失敗：", error);
              }
            },
            editContact(contact) {
              this.editContactData = { ...contact };
              this.showEditModal = true;
            },
            async saveEdit() {
              try {
                const updatedContact = { ...this.editContactData };
                await axios.put(`/contactus/${updatedContact.id}`, updatedContact);
                this.showEditModal = false;
                await this.fetchContacts(); // 更新表格內容
              } catch (error) {
                console.error("更新聯絡資料失敗：", error);
              }
            },
            closeEditModal() {
              this.showEditModal = false;
            },
            prevPage() {
              if (this.hasPreviousPage) this.currentPage--;
            },
            nextPage() {
              if (this.hasNextPage) this.currentPage++;
            },
            goToPage(page) {
              if (page >= 1 && page <= this.totalPages) {
                this.currentPage = page;
              }
            },
            formatDate(date) {
              const d = new Date(date);
              if (isNaN(d)) return "";
              return d.toISOString().replace("T", " ").substring(0, 19);
            },
          },
          mounted() {
            this.fetchContacts();
          },
        };